// The app is light-mode by default. A few pages (e.g. Service Calls) force
// dark locally via the `light` class on <html>; there is no global dark/light
// toggle anymore. getTheme() always resolves to light so any page that restores
// the global theme on unmount lands back on light.

export function getTheme() {
  return "light";
}

export function applyTheme(theme) {
  document.documentElement.classList.toggle("light", theme !== "dark");
}

export function initTheme() {
  applyTheme("light");
}
